// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(min-width:768px)and (max-width:991px){.food-test-header__main-image{position:sticky;z-index:0;top:80px;height:50%}}.food-test-header__right-payment-container{width:100%}@media(min-width:992px)and (max-width:99999px){.food-test-header__right-payment-container{width:50%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
